// /src/config/api.js

// 🚀 Détection automatique du mode (Syntaxe Create React App)
const isProd = process.env.NODE_ENV === 'production';

const API_CONFIG = {
  // Si on est en ligne, on tape sur Railway. Sinon, sur ton PC.
  BASE_URL: isProd ? 'https://smartex-production.up.railway.app' : 'http://localhost:8000',
  
  // Endpoints spécifiques
  ENDPOINTS: {
    ANALYSIS: {
      PROGRESSIVE: '/analyze-progressive',
      PROGRESS: '/get-progress',
      EXAM_RESULTS: '/get-exam-results',
    },
    EMAIL: {
      SEND_REPORT: '/send-email-report',
    },
    FILES: {
      SERVE_AUDIO: '/serve-audio',
      STUDENT_DATA: '/student_data',
    },
    GEMINI: {
      LIVE: '/ws/gemini-live',
    },
    PUSH: {
      SUBSCRIBE: '/api/push/subscribe',
    }
  }
};

// Fonction utilitaire pour construire les URLs complètes HTTP
export const buildApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

// Fonction utilitaire pour construire l'URL WebSocket (ws:// ou wss://)
export const getWebSocketUrl = () => {
  const baseUrl = API_CONFIG.BASE_URL;
  // Si l'URL HTTP est en https, on utilise wss (secure), sinon ws
  const wsProtocol = baseUrl.startsWith('https') ? 'wss' : 'ws';
  // On retire le protocole http/s pour ne garder que le domaine et le port
  const cleanUrl = baseUrl.replace(/^https?:\/\//, '');
  return `${wsProtocol}://${cleanUrl}${API_CONFIG.ENDPOINTS.GEMINI.LIVE}`;
};

// URLs d'API prêtes à l'emploi
export const API_URLS = {
  // Configuration de base
  BASE_URL: API_CONFIG.BASE_URL,
  
  // Analyse
  ANALYZE_PROGRESSIVE: buildApiUrl(API_CONFIG.ENDPOINTS.ANALYSIS.PROGRESSIVE),
  GET_PROGRESS: (userId) => buildApiUrl(`${API_CONFIG.ENDPOINTS.ANALYSIS.PROGRESS}/${userId}`),
  GET_EXAM_RESULTS: (userId) => buildApiUrl(`${API_CONFIG.ENDPOINTS.ANALYSIS.EXAM_RESULTS}/${userId}`),
  
  // Email
  SEND_EMAIL_REPORT: buildApiUrl(API_CONFIG.ENDPOINTS.EMAIL.SEND_REPORT),
  
  // Fichiers
  SERVE_AUDIO: buildApiUrl(API_CONFIG.ENDPOINTS.FILES.SERVE_AUDIO),
  STUDENT_DATA_BASE: buildApiUrl(API_CONFIG.ENDPOINTS.FILES.STUDENT_DATA),
  
  // WebSocket Gemini Live (Dynamique)
  WS_GEMINI_LIVE: getWebSocketUrl(),

  // URL d'abonnement Push dynamique pour la production
  SUBSCRIBE_PUSH: buildApiUrl(API_CONFIG.ENDPOINTS.PUSH.SUBSCRIBE),
};

// Configuration de fetch par défaut
export const defaultFetchOptions = {
  headers: {
    'Content-Type': 'application/json',
  },
};

// Utilitaire pour les requêtes avec gestion d'erreur
export const apiRequest = async (url, options = {}) => {
  try {
    const response = await fetch(url, {
      ...defaultFetchOptions,
      ...options,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('API Request failed:', error);
    throw error;
  }
};

export default API_CONFIG;